module.exports = __webpack_public_path__ + "static/media/GoldenFleece.2e214a5d.jpg";